module.exports = __webpack_public_path__ + "static/media/login.3cc588ed.jpg";